<template>
  <div>
    <ft-navbar></ft-navbar>
    <section>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="section-heading text-uppercase">Eckgesimse <span class="text-muted">({{filtered.length}}/{{eckgesimse.length}})</span>
            </h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <ul>
              <li>Eckgesimse werden meist aus ästhetischen Gründen in der Ecke zwischen Wand und Decke montiert.</li>
              <li>Durch die entstehende Rundung zwischen Wand und Decke wird die Luftzirkulation im Raum begünstigt.
                Dadurch werden dunkle Verfärbungen in den Ecken minimiert
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul>
              <li>Mit Eckgesimsen können auch Unschönheiten wie zum Beispiel Risse auf eine elegante Art kaschiert
                werden.
              </li>
              <li>Hinter Eckgesimsen können auch Vorhangschienen und andere Gleitersysteme versteckt werden</li>
              <li>Auf Wunsch werden auch Massanfertigungen hergestellt.</li>
            </ul>
          </div>
        </div>
        <div class="row my-5">
          <b-form inline>
            <b-form-select class="mb-2 mr-sm-4 mb-sm-1" v-model="height" :options="heights"/>
            <b-form-select class="mb-2 mr-sm-4 mb-sm-1" v-model="style" :options="styles"/>
            <b-form-input type="text" placeholder="Nummer (z.B. 1002)" v-model="mnumber"></b-form-input>
          </b-form>
        </div>
        <div class="row">
          <grid min="240px" v-if="filtered.length">
            <div class="scard" v-for="ecksims in filtered" :key="ecksims.model">
              <div v-if="ecksims.thumbnail" @click="showDetail(ecksims)" class="scard-img-cnt">
                <b-img-lazy :src="ecksims.thumbnail" blank-width="200" blank-height="200" blank-color="#212529"
                            :alt="eckTitle(ecksims.model)"
                            class="scard-img-top img-fluid"/>
              </div>
              <div class="scard-body">
                <h4 class="scard-title">{{eckTitle(ecksims.model)}}</h4>
                <ul class="list-unstyled">
                  <li>Höhe: {{ecksims.height}} cm</li>
                  <li>Tiefe: {{ecksims.depth}} cm</li>
                  <li>Stil: {{niceStyles(ecksims.styles)}}</li>
                </ul>
              </div>
            </div>
          </grid>
          <div class="m-auto" v-else>
            <spinner></spinner>
          </div>
        </div>
      </div>
    </section>
    <b-modal ref="detailModalRef" hide-footer centered size="lg">
      <spinner v-if="imgLoading"></spinner>
      <b-img fluid :src="detailImage" @load="imgLoaded"/>
    </b-modal>
  </div>
</template>

<script>
import ftNavbar from '@/components/FTNavbar'
import Grid from '@/components/Grid'
import Spinner from '@/components/Spinner'
import axios from 'axios'

export default {
  name: 'Eckgesimse',
  components: {ftNavbar, Grid, Spinner},
  data () {
    return {
      eckgesimse: [],
      height: 0,
      style: 0,
      mnumber: null,
      imgLoading: true,
      detailImage: null,
      heights: [
        {value: 0, text: 'Alle Höhen'},
        {value: 1, text: '0cm - 5cm'},
        {value: 2, text: '5cm - 9cm'},
        {value: 3, text: 'grösser 9cm'}
      ],
      styles: []
    }
  },
  computed: {
    filtered () {
      let filteredEck = this.eckgesimse

      if (this.mnumber) {
        return filteredEck.filter(m => ('' + m.model).indexOf('' + this.mnumber) === 0)
      }

      if (this.height === 1) {
        filteredEck = filteredEck.filter(r => r.height <= 5)
      } else if (this.height === 2) {
        filteredEck = filteredEck.filter(r => r.height > 5 && r.height <= 9)
      } else if (this.height === 3) {
        filteredEck = filteredEck.filter(r => r.height > 9)
      }

      if (this.style > 0) {
        filteredEck = filteredEck.filter(r => r.styles.indexOf(this.style) > -1)
      }

      return filteredEck
    }
  },

  methods: {
    eckTitle (model) {
      return 'EG' + model
    },
    mapStyle (style) {
      return this.styles.filter(s => s.value === style).map(s => s.text)
    },
    niceStyles (styles) {
      const qq = styles.map(style => this.mapStyle(style)).filter(style => style)
      return qq.join(', ')
    },
    showDetail (r) {
      if (this.detailImage !== r.detail) {
        this.detailImage = ''
        this.imgLoading = true
        this.detailImage = r.detail
      }
      this.$refs.detailModalRef.show()
    },
    imgLoaded () {
      this.imgLoading = false
    }
  },
  mounted () {
    axios.get(`${this.$api}/eckgesimse/list/`)
      .then(response => {
        this.eckgesimse = response.data.models
        this.styles = response.data.styles
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/Eckgesimse.vue